const defaultInitialState = {
  isPending: false,
  isError: false,
  errorMessage: '',
};

export default defaultInitialState;
